const BASE_URL = process.env.GATSBY_BASE_URL
const LOGIN_URL = process.env.GATSBY_LOGIN_URL
const LOGOUT_URL = `${process.env.GATSBY_AUTH_API_BASE_URL}/logout`
const API_URL = process.env.GATSBY_API_URL
const APP_ID = process.env.GATSBY_APP_ID
const COMPANY_ID = process.env.GATSBY_COMPANY_ID
const CART_API_URL = process.env.GATSBY_CART_API_URL
const PROFILE_API_URL = process.env.GATSBY_PROFILE_API_URL
const CHECKOUT_PAGE_URL = process.env.GATSBY_CHECKOUT_PAGE_URL
const CHECKOUT_API_URL = process.env.GATSBY_CHECKOUT_API_URL
const ESTORE_URL = process.env.GATSBY_ESTORE_URL
const VALIDATE_CAPTCHA_URL = `${process.env.GATSBY_BASE_URL}/validateCaptcha`
const ZENDESK_KEY = process.env.GATSBY_ZENDESK_KEY
const ZENDESK_SECRET = process.env.GATSBY_ZENDESK_SECRET
const PROFILE_PAGE_URL = process.env.GATSBY_PROFILE_PAGE_URL
const PROFILE_ADDRESS_PAGE_URL = process.env.GATSBY_PROFILE_ADDRESS_PAGE_URL
const PROFILE_LOYALTYCARDS_PAGE_URL = process.env.GATSBY_PROFILE_LOYALTYCARDS_PAGE_URL
const PROFILE_CHANGEPASSWORD_PAGE_URL = process.env.GATSBY_PROFILE_CHANGEPASSWORD_PAGE_URL
const PROFILE_ORDERHISTORY_PAGE_URL = process.env.GATSBY_PROFILE_ORDERHISTORY_PAGE_URL
const PROFILE_WISHLIST_PAGE_URL = process.env.GATSBY_PROFILE_WISHLIST_PAGE_URL
const HOME_API_URL = process.env.GATSBY_HOME_API
const B2B_API_URL = process.env.GATSBY_B2B_API

const DEFAULT_APP_LOCATION = { lng: 121.0300684, lat: 14.65695944 } //{ lng: 121.0542674, lat: 14.5834442 }


export {
  BASE_URL,
  LOGIN_URL,
  API_URL,
  APP_ID,
  COMPANY_ID,
  LOGOUT_URL,
  CART_API_URL,
  PROFILE_PAGE_URL,
  PROFILE_API_URL,
  CHECKOUT_PAGE_URL,
  ESTORE_URL,
  VALIDATE_CAPTCHA_URL,
  CHECKOUT_API_URL,
  DEFAULT_APP_LOCATION,
  ZENDESK_KEY,
  ZENDESK_SECRET,
  PROFILE_ADDRESS_PAGE_URL,
  PROFILE_LOYALTYCARDS_PAGE_URL,
  PROFILE_CHANGEPASSWORD_PAGE_URL,
  PROFILE_ORDERHISTORY_PAGE_URL,
  PROFILE_WISHLIST_PAGE_URL,
  HOME_API_URL,
  B2B_API_URL
}
